import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const tableStyle = css`
  display: flex;
  flex-direction: column;
  flex: 1;

  > table {
    table-layout: fixed;
  }
`;

export const severityTag = (color: string) => css`
  width: 100px;

  background-color: ${colors.shadows.getShadow(color, 0.1)};

  & span {
    margin-left: 10px;
    color: ${color};
  }

  & svg {
    color: ${color};
    width: 16px;
    height: 16px;
  }
`;
